import {
  ICON__check_double_solid,
  ICON__flame,
  ICON__language_solid,
  ICON__palette_solid,
  ICON__table_cells_large_solid,
  ICON__user_solid,
} from '@/assets/icons_fa';
import { LAYOUT_COLUMN__left } from '@/pages/_base/layout_base/LAYOUT_COLUMN__left';
import { FOOTER__master } from '@/pages/_base/layout_footer/FOOTER__master';
import { HEADER__master } from '@/pages/_base/layout_header/HEADER__master';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useTranslation } from 'react-i18next';
import { S_BUTTON__settings_user_tab } from './S_BUTTON__settings_user_tab';
import { ENUM__settings_user_tab } from './_base/ENUM__settings_user_tab';
import { S_TAB__user_account } from './account/S_TAB_user_account';
import { TabSettingsUserCollections } from './collections/TabSettingsUserCollections';
import { TabSettingsUserConfirmationOfActions } from './confirmation_of_actions/TabSettingsUserConfirmationOfActions';
import { TabSettingsUserGeneration } from './generation/TabSettingsUserGeneration';
import { S_TAB__regional } from './regional/S_TAB__regional';
import { TabSettingsUserUI } from './ui/TabSettingsUserUI';

export function S_PAGE_LAYOUT__settings_user_desktop() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_USER);

  //FIELDS
  /*
   * HTML
   */
  return (
    <div className="relative flex flex-col w-full  h-screen">
      <HEADER__master />

      <div className="flex flex-row w-full flex-1 min-h-0">
        <LAYOUT_COLUMN__left>
          <div className="flex flex-col gap-0 p-2 size-full overflow-y-auto bg-component">
            <S_BUTTON__settings_user_tab type={ENUM__settings_user_tab.ACCOUNT} Icon={ICON__user_solid} />
            <S_BUTTON__settings_user_tab type={ENUM__settings_user_tab.REGIONAL} Icon={ICON__language_solid} />
            <S_BUTTON__settings_user_tab type={ENUM__settings_user_tab.UI} Icon={ICON__palette_solid} />
            <S_BUTTON__settings_user_tab type={ENUM__settings_user_tab.GENERATION} Icon={ICON__flame} />
            <S_BUTTON__settings_user_tab type={ENUM__settings_user_tab.COLLECTIONS} Icon={ICON__table_cells_large_solid} />
            <S_BUTTON__settings_user_tab type={ENUM__settings_user_tab.CONFIRMATION_OF_ACTIONS} Icon={ICON__check_double_solid} />
          </div>
        </LAYOUT_COLUMN__left>
        {/*
         *
         */}
        <div className="flex-1 flex flex-col h-full min-h-0 min-w-0">
          <S_TAB__user_account />
          <S_TAB__regional />
          <TabSettingsUserUI />
          <TabSettingsUserGeneration />
          <TabSettingsUserCollections />
          <TabSettingsUserConfirmationOfActions />
        </div>
      </div>
      {/*
       *
       */}

      <FOOTER__master />
    </div>
  );
}
